module.exports = __webpack_public_path__ + "static/media/TipOutSS.7c535685.png";